import { Card } from "@mui/material";
import AttendanceFilters from "./AttendanceFilters";
import AttendanceTable from "./AttendanceTable";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";

function AttendanceDashboard() {
  return (
    <DashboardLayout>
      <Card sx={{maxHeight:"max-content",minHeight:"500px",paddingBottom:"30px"}}>
        <AttendanceFilters />
        <AttendanceTable />
      </Card>
    </DashboardLayout>
  );
}

export default AttendanceDashboard;
